import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import ReactPaginate from 'react-paginate';
import { propFunc, propNumber } from '../../../../helpers/custom-prop-types';
const SlideSearchPaginate = (props) => {
    const { onChangePage, page, total } = props;
    if (total === 0) {
        return null;
    }
    // 6/10000
    return (_jsx("div", Object.assign({ className: 'slide_search_pagination' }, { children: _jsx(ReactPaginate, { activeClassName: 'active', forcePage: (page || 1) - 1, marginPagesDisplayed: 3, nextLabel: '>', onPageChange: onChangePage, pageCount: Math.min(Math.ceil(total / 6), 1500), pageRangeDisplayed: 5, previousLabel: '<' }) })));
};
SlideSearchPaginate.propTypes = {
    onChangePage: propFunc().isRequired,
    page: propNumber(),
    total: propNumber().isRequired,
};
SlideSearchPaginate.defaultProps = {
    page: 1,
};
export default SlideSearchPaginate;
